// Eagerly loaded provider singletons. Used on the Landing route, so
// they stay in the initial bundle. The PDF engine is lazily loaded
// per `src/app/engine.ts` — see the Suspense split in `App.tsx`.

import { DEVICE_PROVIDER_ID, DeviceStorageProvider, ProviderRegistry } from '@recto/provider';

let registry: ProviderRegistry | null = null;
let deviceProvider: DeviceStorageProvider | null = null;

/**
 * The app-wide `ProviderRegistry` singleton. Lazily initialised so
 * this module can be imported for its types without paying the
 * registration cost. Idempotent on repeat calls (safe under Vite HMR).
 */
export function getProviderRegistry(): ProviderRegistry {
  if (registry === null) {
    registry = new ProviderRegistry();
    const device = getDeviceProvider();
    registry.register({
      id: DEVICE_PROVIDER_ID,
      displayName: 'Device',
      storage: () => device,
    });
  }
  return registry;
}

/**
 * The app-wide `DeviceStorageProvider` singleton. Guest mode uses
 * this for open / save flows.
 */
export function getDeviceProvider(): DeviceStorageProvider {
  if (deviceProvider === null) {
    deviceProvider = new DeviceStorageProvider();
  }
  return deviceProvider;
}
